module.exports = __webpack_public_path__ + "img/comment.cdb137e1.svg";